import React, { useState } from "react"
import styled from "styled-components"
import DateFnsUtils from "@date-io/date-fns"
import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers"
import lightBlue from "@material-ui/core/colors/lightBlue"
import { createMuiTheme } from "@material-ui/core"
import { ThemeProvider } from "@material-ui/styles"

const materialTheme = createMuiTheme({
  spacing: 2,
  typography: {
    fontSize: 20,
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#2f2f2f",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: "#0066ff",
      main: "#0044ff",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#ffcc00",
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#636363", //lightBlue.A200,
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: "white",
      },
    },
    MuiPickersDay: {
      day: {
        color: "#434343",
      },
      daySelected: {
        backgroundColor: "#595959", //lightBlue["400"],
      },
      dayDisabled: {
        color: "#CDCDCD", //lightBlue["100"],
      },
      current: {
        color: lightBlue["900"],
      },
    },
  },
})

const MainBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background-color: blue; */
  padding-bottom: 1.3rem;
  padding-top: 0.2rem;
`

const PickersBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

const PickerBox = styled.div`
  display: flex;
  width: 48%;
  justify-content: center;
  // align-items: center;
  flex-direction: column;
  cursor: pointer;
  & input {
    font-size: 1.6rem;
    transform: scale(0.8);
  }
`

const LabelBox = styled.div`
  display: flex;
  width: 100%;
  // justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  padding-bottom: 0.8rem;
  color: #2f2f2f;
`

const ErrorBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  color: red;
  margin-top: 0.6rem;
`

function DateAndTimePicker(props) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <ThemeProvider theme={materialTheme}>
        <MainBox>
          <PickersBox>
            <PickerBox>
              <LabelBox>Event Date *</LabelBox>
              <DatePicker
                // variant="inline"
                disabled={props.disabled}
                minDate={!props.disabled && props.minDate}
                disablePast={!props.disabled}
                value={props.selectedDate}
                onChange={date => {
                  props.setSelectedDate(date)
                  if (!props.disabled && props.setErrors) {
                    props.setErrors({ ...props.errrors, selectedDate: "" })
                  }
                }}
                format={"MMMM dd, yyyy"}
              />
            </PickerBox>
            <PickerBox>
              <LabelBox>Event Time *</LabelBox>
              <TimePicker
                disabled={!props.selectedDate || props.disabled}
                value={props.selectedDate}
                onChange={date => {
                  props.setSelectedDate(date)
                  props.setErrors({ ...props.errors, selectedDate: "" })
                }}
              />
            </PickerBox>
          </PickersBox>
          <ErrorBox>{props.errors.selectedDate}</ErrorBox>
        </MainBox>
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  )
}

export default DateAndTimePicker

export function EgrDatePicker(props) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <ThemeProvider theme={materialTheme}>
        <MainBox>
          <PickersBox>
            <PickerBox>
              <LabelBox>{props.label}</LabelBox>
              <DatePicker
                disabled={props.disabled}
                minDate={!props.disabled && props.minDate}
                maxDate={props.maxDate}
                maxDateMessage={props.maxDateMessage}
                minDateMessage={props.minDateMessage}
                value={props.selectedDate}
                onChange={date => {
                  props.setSelectedDate(date)
                  if (!props.disabled && props.setErrors) {
                    props.setErrors({
                      ...props.errors,
                      [props.errorFieldForm]: "",
                      [props.errorFieldAlias]: "",
                    })
                  }
                }}
                onError={error => {
                  // console.log("OnError error:", error)
                  if (
                    !props.disabled &&
                    !props.errors[props.errorFieldAlias] &&
                    props.setErrors &&
                    error
                  ) {
                    props.setErrors({
                      ...props.errors,
                      [props.errorFieldAlias]: `${props.maxDateMessage}`,
                    })
                  }
                }}
                format={"MMMM dd, yyyy"}
              />
            </PickerBox>
          </PickersBox>
          <ErrorBox>{props.error}</ErrorBox>
        </MainBox>
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  )
}

export function EgrTimePicker(props) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <MainBox>
        <PickersBox>
          <PickerBox>
            <LabelBox>{props.label}</LabelBox>
            <TimePicker
              value={props.selectedDate}
              onChange={props.setSelectedDate}
            />
          </PickerBox>
        </PickersBox>
        <ErrorBox>{props.error}</ErrorBox>
      </MainBox>
    </MuiPickersUtilsProvider>
  )
}
